(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const bind = () => {
      document.querySelectorAll('[data-bb-contact]').forEach(form => {
        if (form.dataset.bbContactBound === 'true') return;
        const fields = form.querySelector('[data-bb-contact-fields]');
        const button = form.querySelector('[type="submit"]');
        const status = form.querySelector('[data-bb-contact-status]');
        const area = form.querySelector('[data-bb-contact-area]');
        const privacy = form.querySelector('[name="contact[privacy_acknowledged]"]');
        if (!fields || !button || !status || !area || !privacy) return;
        let busy = false;
        let submitted = false;
        const originalLabel = button.textContent;
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (busy || submitted || !form.reportValidity() || !privacy.checked) return;
          const fd = new FormData(form);
          const read = name => String(fd.get(name) || '').trim();
          const payload = {
            name: read('contact[name]'),
            phone: read('contact[phone]'),
            email: read('contact[email]'),
            comune: read('contact[indirizzo]'),
            body: read('contact[body]'),
            privacy_acknowledged: '1',
            website: read('website'),
            address_lat: read('address_lat'),
            address_lon: read('address_lon'),
            source: 'contatti',
            request_type: 'contact_request',
            tipo_intervento: 'Richiesta informazioni'
          };
          status.classList.remove('is-error', 'is-success');
          area.hidden = true;
          if (['name', 'phone', 'email', 'comune', 'body'].some(key => !payload[key])) {
            status.textContent = form.dataset.required;
            status.classList.add('is-error');
            status.hidden = false;
            status.focus();
            return;
          }
          busy = true;
          fields.disabled = true;
          button.disabled = true;
          button.textContent = form.dataset.pending;
          form.setAttribute('aria-busy', 'true');
          status.textContent = form.dataset.pending;
          status.hidden = false;
          const controller = new AbortController();
          let timer;
          const bbSafeMsg = (m, f) => { m = typeof m === 'string' ? m.trim() : ''; return m && m.length <= 200 && !/[<>{}\[\]\\$=`|]|https?:|\.php|(^|[\s(])\/\w|\b(sql|php|pdo|mysql|exception|stack|trace|fatal|warning|notice|undefined|errno|apache|nginx|linux|aruba|server|token|api)\b/i.test(m) ? m : f; };
          try {
            if (window.bbCaptcha) payload.cf_turnstile = await window.bbCaptcha.token();
            timer = setTimeout(() => controller.abort(), 25000);
            const response = await fetch(form.action, {
              method: 'POST', mode: 'cors', credentials: 'omit',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify(payload), signal: controller.signal
            });
            const data = await response.json().catch(() => null);
            if (!response.ok || data?.ok !== true) {
              const detail = bbSafeMsg(data?.error, form.dataset.error);
              throw new Error(detail);
            }
            submitted = true;
            status.textContent = form.dataset.success + (typeof data.practice === 'string' ? ' ' + form.dataset.practice + ' ' + data.practice + '.' : '');
            status.classList.add('is-success');
            area.hidden = false;
            form.reset();
            form.querySelectorAll('.bb-address-results').forEach(results => { results.hidden = true; });
          } catch (error) {
            status.textContent = error.name === 'AbortError' || error instanceof TypeError || ['captcha', 'timeout'].includes(error.message) ? form.dataset.error : error.message || form.dataset.error;
            status.classList.add('is-error');
          } finally {
            clearTimeout(timer);
            busy = false;
            fields.disabled = submitted;
            button.disabled = submitted;
            button.textContent = originalLabel;
            form.removeAttribute('aria-busy');
            status.focus();
          }
        });
        form.dataset.bbContactBound = 'true';
        fields.disabled = false;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once: true});
    else bind();
    document.addEventListener('shopify:section:load', bind);
  })();
  } catch(e) { console.error(e); }
})();

})();
